/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The PartnerKeyIdBody model module.
 * @module model/PartnerKeyIdBody
 * @version 1.0.0
 */
export class PartnerKeyIdBody {
  /**
   * Constructs a new <code>PartnerKeyIdBody</code>.
   * @alias module:model/PartnerKeyIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PartnerKeyIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PartnerKeyIdBody} obj Optional instance to populate.
   * @return {module:model/PartnerKeyIdBody} The populated <code>PartnerKeyIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PartnerKeyIdBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
PartnerKeyIdBody.prototype.title = undefined;

/**
 * @member {String} description
 */
PartnerKeyIdBody.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
PartnerKeyIdBody.prototype.enabled = undefined;

